import { IConfig } from '@cian/config/shared';

import {
  INewbuildingBroker,
  TSource,
} from '../../../repositories/newbuilding-flat-view-order/entities/consulting_request/NewbuildingBroker';
import { getCianSource, isNewbuildingBrokerCianSource } from '../../../utils/cianSource';
import { toCamelCase } from '../../../utils/formatters';

export const prepareNewbuildingBroker = (config: IConfig): INewbuildingBroker | undefined => {
  const cianSource = getCianSource();

  if (cianSource && isNewbuildingBrokerCianSource(cianSource, config)) {
    return {
      source: toCamelCase(cianSource) as TSource,
    };
  }

  return undefined;
};
